import React from "react";

import { IDevice } from "@formant/core/model/IDevice";

import { useRouter } from "../../../context/RouterContext";
import { RestrictedComponent } from "../../common/RestrictedComponent";
import { TextButton } from "../../common/TextButton";
import { ErrorPage } from "../../ErrorPage";

export interface INoDeviceProps {
    device: IDevice | false;
}

export function NoDevice(props: INoDeviceProps) {
    const { device } = props;
    const { routeTo } = useRouter();
    return (
        <ErrorPage
            title="Not found"
            message={
                device === false
                    ? "This device can't be found"
                    : !device.enabled
                      ? "This device has been disabled"
                      : undefined
            }
            reload={true}
        >
            <RestrictedComponent
                resource="devices"
                requiredAccess="administrator"
            >
                <TextButton to={routeTo.createDevice()}>
                    Click here to set up a new device
                </TextButton>
            </RestrictedComponent>
        </ErrorPage>
    );
}
